import React from 'react'

export function PinIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12 18v4.5m8.158-5.409a4.503 4.503 0 00-1.89-2.821.75.75 0 01-.32-.549L16.942 3.675A.75.75 0 0016.196 3H7.804a.75.75 0 00-.747.675L6.053 13.721a.749.749 0 01-.32.549 4.503 4.503 0 00-1.891 2.821.752.752 0 00.733.909h14.85a.752.752 0 00.733-.909z'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
